// TODO: Add cache for RegExp objects
export default function replaceRegex(regularExpressionSearch, replacement, subject) {
	return subject.replace(new RegExp(regularExpressionSearch, 'g'), replacement);
}
